import type { PostMessageInput, TransitionInput } from './types';

/**
 * Conversation 작업 API 래퍼 — 어댑터에서 사용. fetch 인자 흩어짐 방지.
 * 모든 호출이 같은 인증 cookie + 같은 에러 모델 (j.success/j.error) 을 통과.
 */
export interface ConversationApi {
 transitionStatus: (cid: string, input: TransitionInput) => Promise<void>;
 postMessage: (cid: string, input: PostMessageInput) => Promise<void>;
 archive: (cid: string, archived?: boolean) => Promise<void>;
}

async function jsonOk(r: Response): Promise<void> {
 const j = await r.json().catch(() => ({ success: false, error: '응답 파싱 실패' }));
 if (!j.success) throw new Error(j.error || `요청 실패 (${r.status})`);
}

export const conversationApi: ConversationApi = {
 transitionStatus: async (cid, input) => {
  const r = await fetch(`/messages/${cid}/status`, {
   method: 'PATCH',
   credentials: 'include',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify(input),
  });
  await jsonOk(r);
 },
 postMessage: async (cid, input) => {
  const r = await fetch(`/messages/${cid}`, {
   method: 'POST',
   credentials: 'include',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify(input),
  });
  await jsonOk(r);
 },
 archive: async (cid, archived = true) => {
  const r = await fetch(`/messages/${cid}/archive`, {
   method: 'PATCH',
   credentials: 'include',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify({ archived }),
  });
  await jsonOk(r);
 },
};
